import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { navLinks, agency } from "../mock";
import { Button } from "./ui/button";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background/95 backdrop-blur-md shadow-sm py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => go("#accueil")} className="flex flex-col items-start leading-none">
          <span
            className={`font-serif text-2xl md:text-[28px] font-semibold tracking-[0.18em] transition-colors ${
              scrolled ? "text-foreground" : "text-white"
            }`}
          >
            SOLÈS IMMO
          </span>
          <span
            className={`text-[10px] tracking-[0.35em] mt-0.5 transition-colors ${
              scrolled ? "text-accent" : "text-white/80"
            }`}
          >
            BOULOGNE-BILLANCOURT
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden xl:flex items-center gap-5">
          {navLinks.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className={`nav-link text-sm tracking-wide font-medium ${
                scrolled ? "text-foreground/80 hover:text-accent" : "text-white/90 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-4">
          <a
            href={`tel:${agency.phoneHref}`}
            className={`flex items-center gap-2 text-sm font-medium ${
              scrolled ? "text-foreground" : "text-white"
            }`}
          >
            <Phone className="h-4 w-4 text-accent" />
            {agency.phone}
          </a>
          <Button
            onClick={() => go("#contact")}
            className="bg-accent hover:bg-accent/90 text-accent-foreground rounded-full px-6"
          >
            Nous contacter
          </Button>
        </div>

        {/* Mobile toggle */}
        <button
          className={`xl:hidden ${scrolled ? "text-foreground" : "text-white"}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="xl:hidden bg-background border-t border-border mt-3 px-5 py-4 shadow-lg">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                className="text-left py-2.5 text-foreground/85 hover:text-accent border-b border-border/60 last:border-0"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <Button
            onClick={() => go("#contact")}
            className="w-full mt-4 bg-accent hover:bg-accent/90 text-accent-foreground rounded-full"
          >
            Nous contacter
          </Button>
        </div>
      )}
    </header>
  );
}
